module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABRElEQVR4AWMYHMAzxO9/0aEZ/6VXxPxnmOdJPIYBPRaO/4qK8v+PHTv2f++zC/+Tj0z4z78khHgDzgiq/U/jEP7PzMz4v6Eq9v+f39////z7+/+6B0f/++1p/M+2wBe/AeeABoDwPF7Z/9JMrP+tjTj/3zmW8v/fl6P/QeDtj0//Z97Y9t9+WxluA2D4kIDKf0823v/8PIz/F7fz/f9zTf//3+dt//9/vwk27MnXN/9bLiz/r7UuHdUANAySBOM/F8XgGA1gN+AI0AXebHz/ebgY/y9ohbrgWeP/f98uw13QdWn1f4MN2ZgGLOCVA4eBhT4HMAyS/v/7fBis6cPPL//n3Nzx32l7Be5YyOCExEJdeSQ8FjY+PP4/cG8z4VgwYOEEp4PDhw//P/D80v+0o5P+Cy0NIz4deAb5/i85SEZKHB4AADGdYwAQsz7HAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GY.png
// module id = 1158
// module chunks = 0